import React from 'react';
interface OpenFpgaLogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function OpenFpgaLogo({
  className = '',
  size = 'md'
}: OpenFpgaLogoProps) {
  const sizeClasses = {
    sm: 'h-5',
    md: 'h-7',
    lg: 'h-10',
    xl: 'h-14 md:h-20'
  };
  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-xl',
    lg: 'text-3xl',
    xl: 'text-4xl md:text-6xl'
  };
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-1">
      {/* Logo Icon - 2x2 Grid representing FPGA logic blocks */}
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${sizeClasses[size]} text-brand-primary`} data-id="element-2">
        <rect x="2" y="2" width="9" height="9" rx="2" fill="currentColor" fillOpacity="0.9" data-id="element-3" />
        <rect x="13" y="2" width="9" height="9" rx="2" fill="currentColor" fillOpacity="0.9" data-id="element-4" />
        <rect x="2" y="13" width="9" height="9" rx="2" fill="currentColor" fillOpacity="0.9" data-id="element-5" />
        <rect x="13" y="13" width="9" height="9" rx="2" fill="currentColor" fillOpacity="0.9" data-id="element-6" />
      </svg>

      {/* Wordmark */}
      <div className={`font-sans tracking-tight leading-none ${textSizeClasses[size]}`} data-id="element-7">
        <span className="font-medium text-white" data-id="element-8">Open</span>
        <span className="font-bold text-white" data-id="element-9">FPGA</span>
      </div>
    </div>;
}